/* eslint-disable import/first */
import React from 'react';
import { Grid, Button, Typography } from '@material-ui/core';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

const Writeus = ({ email }) => {
  return (
    <Grid className={css.writeusContainer}>
      <Grid className={css.headerText}>
        <Typography>
          <FormattedMessage id="write_to_us" defaultMessage="Write to Us" />
        </Typography>
      </Grid>
      <Grid className={css.descText}>
        <Typography>
          <FormattedMessage
            id="queries_email"
            defaultMessage="For any queries, email us quoting your mobile number."
          />
        </Typography>
      </Grid>
      <Grid>
        <Button className={css.supportButton} mailto={`mailto:${email}`}>
          <a href={`mailto:${email}?subject=SendMail&body=Description`}>
            <Typography>{email}</Typography>
          </a>
        </Button>
      </Grid>
    </Grid>
  );
};

export default Writeus;
